export const getWeightTypeLabel = (weightType: string | null | undefined) => {
  const normalized = (weightType || '').trim().toLowerCase();
  if (normalized === 'kg' || normalized === 'кг') return 'кг';
  if (normalized === 'g' || normalized === 'г') return 'г';
  if (normalized === 'l' || normalized === 'л') return 'л';
  if (normalized === 'ml' || normalized === 'мл') return 'мл';
  if (normalized === 'pcs' || normalized === 'шт' || normalized === 'шт.') return 'шт';
  return weightType || '—';
};

export const escapeHtml = (value: string) =>
  value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');

export const getInventoryPrintStyles = () => `
  .pdf-receipt-root { font-family: Arial, sans-serif; width: 100%; color: #2c3e50; }
  body, body * { print-color-adjust: exact; -webkit-print-color-adjust: exact; }
  .receipt-sheet { border: 2px solid #d7e3ef; border-radius: 10px; padding: 12px; margin-bottom: 14px; background: #fff; }
  .receipt-top { border-bottom: 2px solid #2980b9; padding-bottom: 8px; margin-bottom: 10px; background: linear-gradient(180deg, #f7fbff 0%, #ffffff 100%); }
  .receipt-title-row { display: flex; justify-content: space-between; align-items: center; gap: 8px; margin-bottom: 6px; }
  .receipt-title-row h2 { margin: 0; font-size: 20px; color: #1f4f7a; }
  .page-index { font-size: 12px; color: #5d6d7e; font-weight: 600; }
  .receipt-meta-grid { display: grid; grid-template-columns: repeat(2, minmax(220px, 1fr)); gap: 4px 12px; font-size: 12px; color: #2f3f4f; }
  .pdf-receipt-root table { width: 100%; border-collapse: collapse; margin-top: 8px; }
  .pdf-receipt-root th, .pdf-receipt-root td { border: 1px solid #dfe6e9; padding: 7px 8px; font-size: 12px; }
  .pdf-receipt-root th { background: #eef4fa; color: #2c3e50; text-align: left; }
  .receipt-bottom { border-top: 2px solid #2980b9; margin-top: 12px; padding-top: 8px; display: flex; justify-content: space-between; gap: 12px; font-size: 12px; color: #2f3f4f; }
`;
